"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDirection = exports.OrderDirectionArray = exports.ValueTypeDefArray = exports.ValueTypeOf = exports.ValueTypeOfArray = exports.TernaryOperation = exports.TernaryOperationArray = exports.BinaryOperation = exports.BinaryOperationArray = exports.UnaryOperation = exports.UnaryOperationArray = exports.Bool = exports.BoolArray = void 0;
exports.BoolArray = ['and', 'or', 'not'];
exports.Bool = new Set(exports.BoolArray);
exports.UnaryOperationArray = ['is null', 'is not null'];
exports.UnaryOperation = new Set(exports.UnaryOperationArray);
exports.BinaryOperationArray = [
    '=',
    '!=',
    '<',
    '>',
    '<=',
    '>=',
    '!=',
    '<>',
    '^=',
    '~=',
    '~',
    '~*',
    '!~',
    '!~*',
    'like',
    'not like',
    'similar to',
    'not similar to',
];
exports.BinaryOperation = new Set(exports.BinaryOperationArray);
exports.TernaryOperationArray = ['between', 'not between'];
exports.TernaryOperation = new Set(exports.TernaryOperationArray);
exports.ValueTypeOfArray = ['string', 'number', 'boolean', 'bigint'];
exports.ValueTypeOf = new Set(exports.ValueTypeOfArray);
exports.ValueTypeDefArray = ['string', 'long', 'date', 'dateTime', 'blob', 'seqId', 'decimal'];
exports.OrderDirectionArray = ['asc', 'desc'];
exports.OrderDirection = new Set(exports.OrderDirectionArray);
//# sourceMappingURL=filter.js.map